import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { getPasswordRequirementState } from '@/lib/password-validation';
import { cn } from '@/lib/utils';

export default function PasswordRequirements({ password }) {
  const { lenOk, capOk, specOk } = getPasswordRequirementState(password);

  const itemClass = (ok) =>
    cn(
      'mb-1 flex items-center gap-2 text-sm',
      ok ? 'text-[var(--bethere-success)]' : 'text-[var(--festy-muted-text)]',
    );

  return (
    <ul className="mt-2 list-none space-y-1 p-0">
      <li className={itemClass(lenOk)}>
        <FontAwesomeIcon icon={['fas', 'circle-check']} />8 Characters
      </li>
      <li className={itemClass(capOk)}>
        <FontAwesomeIcon icon={['fas', 'circle-check']} />
        One Capitalized Letter
      </li>
      <li className={itemClass(specOk)}>
        <FontAwesomeIcon icon={['fas', 'circle-check']} />
        One Special Character
      </li>
    </ul>
  );
}
